import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/index.scss'

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.$beforeUpload = function(file) {
  const maxSize = 10 * 1024 * 1024
  if (file.size > maxSize) {
    this.$message.error('图片太大')
    return false
  }
  return true
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
